import React, {Fragment} from 'react'
import { connect } from 'react-redux'
import { Dropdown } from 'react-bootstrap'
import { setSortAscending, setPrSortingType } from '../../actions/survey'
import styled from 'styled-components'

const mapStateToProps = ({ survey: { prSortingType, sortAscending } }) => {
  return {
    prSortingType,
    sortAscending,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetPrSortingType: (type) => {
      dispatch(setPrSortingType(type));
    },
    onSetSortAscending: (ascending) => {
      dispatch(setSortAscending(ascending));
    },
  };
};

const PrSortingWidget = ({
  useTranslate,
  prSortingType,
  sortAscending,
  onSetSortAscending,
  onSetPrSortingType,
  disabled = false,
  hideImportance = false
}) => {

  const setSorting = (type, asc) => {
    onSetSortAscending(asc);
    onSetPrSortingType(type)
  }

  const getActiveText = () => {
    if (prSortingType === "byResultProgress" && !sortAscending) {
      return useTranslate('progress_reports.result_progress_descending')
    } else if (prSortingType === "byResultProgress" && sortAscending) {
      return useTranslate('progress_reports.result_progress_ascending')
    } else if (prSortingType === "byRateProgress" && !sortAscending) {
      return useTranslate('progress_reports.importance_progress_descending')
    } else if (prSortingType === "byRateProgress" && sortAscending) {
      return useTranslate('progress_reports.importance_progress_ascending')
    } else if (prSortingType === "byLatestResult" && !sortAscending) {
      return useTranslate('progress_reports.latest_current_state_descending')
    } else if (prSortingType === "byLatestResult" && sortAscending){
      return useTranslate('progress_reports.latest_current_state_ascending')
    } else if (prSortingType === "byLatestRate" && !sortAscending){
      return useTranslate('progress_reports.latest_importance_descending')
    } else if (prSortingType === "byLatestRate" && sortAscending){
      return useTranslate('progress_reports.latest_importance_ascending')
    } else {
      return useTranslate('progress_reports.result_progress_descending')
    }
  }

  if (hideImportance && (prSortingType === "byRateProgress" || prSortingType === "byLatestRate")) {
    setSorting("byResultProgress", false);
  }

  return (
    <div className="sorting-container">
      <label htmlFor="selectSorting">{ useTranslate("data_vault.sort_dropdown_label") }</label>
      <DDWrapper className={`dropdown-sorting ${disabled ? "disabled" : ""}`}>
        <Dropdown>
          <Dropdown.Toggle id="toggle-dropdown-sorting">
            { getActiveText() }
            <span className="ant-select-arrow" />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => setSorting("byResultProgress", false)}
              className={`${prSortingType === "byResultProgress" && !sortAscending ? 'active' : ''}`}
            >
              { useTranslate('progress_reports.result_progress_descending') }
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => setSorting("byResultProgress", true)}
              className={`${prSortingType === "byResultProgress" && sortAscending ? 'active' : ''}`}
            >
              { useTranslate('progress_reports.result_progress_ascending') }
            </Dropdown.Item>
            {!hideImportance &&
              <Fragment>
                <Dropdown.Item
                  onClick={() => setSorting("byRateProgress", false)}
                  className={`${prSortingType === "byRateProgress" && !sortAscending ? 'active' : ''}`}
                >
                  { useTranslate('progress_reports.importance_progress_descending') }
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => setSorting("byRateProgress", true)}
                  className={`${prSortingType === "byRateProgress" && sortAscending ? 'active' : ''}`}
                >
                  { useTranslate('progress_reports.importance_progress_ascending') }
                </Dropdown.Item>
              </Fragment>
            }
            <Dropdown.Item
              onClick={() => setSorting("byLatestResult", false)}
              className={`${prSortingType === "byLatestResult" && !sortAscending ? 'active' : ''}`}
            >
              { useTranslate('progress_reports.latest_current_state_descending') }
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => setSorting("byLatestResult", true)}
              className={`${prSortingType === "byLatestResult" && sortAscending ? 'active' : ''}`}
            >
              { useTranslate('progress_reports.latest_current_state_ascending') }
            </Dropdown.Item>
            {!hideImportance &&
              <Fragment>
                <Dropdown.Item
                  onClick={() => setSorting("byLatestRate", false)}
                  className={`${prSortingType === "byLatestRate" && !sortAscending ? 'active' : ''}`}
                >
                  { useTranslate('progress_reports.latest_importance_descending') }
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => setSorting("byLatestRate", true)}
                  className={`${prSortingType === "byLatestRate" && sortAscending ? 'active' : ''}`}
                >
                  { useTranslate('progress_reports.latest_importance_ascending') }
                </Dropdown.Item>
              </Fragment>
            }
          </Dropdown.Menu>
        </Dropdown>
      </DDWrapper>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(PrSortingWidget);

const DDWrapper = styled.div`
 &.disabled {
  opacity: 0.6;
  pointer-events: none;
 }
`;


// WEBPACK FOOTER //
// ./src/components/ui/sorting-widget-progress-reports.js